import { IStyle } from '@fluentui/react';
import { FontWeights } from '@h2oai/ui-kit';

export interface IRetrieveStyles {
  root?: IStyle;
  form?: IStyle;
  messageBar?: IStyle;
  fields?: IStyle;
  subTitle?: IStyle;
  result?: IStyle;
  buttons?: IStyle;
}

export interface IRetrieveClassNames {
  root: string;
  form: string;
  messageBar: string;
  fields: string;
  subTitle: string;
  result: string;
  buttons: string;
}

export const retrieveStylesDefault: Partial<IRetrieveStyles> = {
  root: {
    flex: 1,
    height: '100%',
    paddingTop: 17,
  },
  form: { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 },
  messageBar: { position: 'absolute', zIndex: 1, right: '0px', top: '-81px' },
  fields: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  result: {
    flex: 1,
  },
  subTitle: {
    fontWeight: FontWeights.semiBold,
  },
  buttons: { display: 'flex', gap: '8px', justifyContent: 'flex-end' },
};
